import { ReactiveVar, makeVar } from "@apollo/client";

export const questionsCountVar: ReactiveVar<number> = makeVar<number>(0);

export const answeredQuestionsCountVar: ReactiveVar<number> = makeVar<number>(
  0
);
